"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const berkeleydb_1 = require("./berkeleydb");
const rpm_1 = require("./rpm");
const sql_js_1 = require("sql.js");
/**
 * Get a list of packages given a Buffer that contains an RPM database in BerkeleyDB format.
 * The database is inspected as best-effort, returning all valid/readable entries.
 * @param data An RPM database in BerkeleyDB format.
 * @deprecated Should use snyk/dep-graph. The response format is kept for backwards compatibility with snyk/kubernetes-monitor.
 */
async function getPackages(data) {
    try {
        const berkeleyDbValues = await berkeleydb_1.bufferToHashDbValues(data);
        let packagesSkipped = 0;
        let packagesProcessed = 0;
        const rpmPackageInfos = new Array();
        for (const entry of berkeleyDbValues) {
            try {
                const packageInfo = await rpm_1.bufferToPackageInfo(entry);
                if (packageInfo !== undefined) {
                    rpmPackageInfos.push(packageInfo);
                    packagesProcessed += 1;
                }
                else {
                    packagesSkipped += 1;
                }
            }
            catch (error) {
                packagesSkipped += 1;
            }
        }
        const formattedPackages = formatRpmPackages(rpmPackageInfos);
        const response = formattedPackages.join('\n');
        return {
            response,
            rpmMetadata: {
                packagesProcessed,
                packagesSkipped,
            },
        };
    }
    catch (error) {
        return {
            response: '',
            error: error,
        };
    }
}
exports.getPackages = getPackages;
function formatRpmPackages(packages) {
    return packages.map((packageInfo) => {
        return `${packageInfo.name}\t${formatRpmPackageVersion(packageInfo)}\t${packageInfo.size}`;
    });
}
function formatRpmPackageVersion(packageInfo) {
    if (packageInfo.epoch === undefined || packageInfo.epoch === 0) {
        return `${packageInfo.version}-${packageInfo.release}`;
    }
    return `${packageInfo.epoch}:${packageInfo.version}-${packageInfo.release}`;
}
exports.formatRpmPackageVersion = formatRpmPackageVersion;
/**
 * Get a list of packages given a file path to an Sqlite RPM packages DB.
 * The database is inspected as best-effort, returning all valid/readable entries.
 * @param sqliteFilePath A path to an RPM sqlite Packages DB.
 */
async function getPackagesSqlite(sqliteDbBuffer) {
    try {
        const packageInfoBlobs = await getBlobsFromPackagesTableSqliteDb(sqliteDbBuffer);
        const packages = await Promise.all(packageInfoBlobs.map((data) => rpm_1.bufferToPackageInfo(data)));
        return { response: packages };
    }
    catch (error) {
        return { response: [], error: error };
    }
}
exports.getPackagesSqlite = getPackagesSqlite;
// TODO: revisit when new version of sql.js is available
// OR we're able to use sqlite3 (Snyk CLI limitation with native modules)
async function getBlobsFromPackagesTableSqliteDb(sqliteDbBuffer) {
    const SQL = await sql_js_1.default();
    const db = new SQL.Database(sqliteDbBuffer);
    const dbContent = db.exec('SELECT blob FROM Packages');
    const packagesInfoBlobs = dbContent[0].values;
    db.close();
    return packagesInfoBlobs.map((data) => Buffer.from(data[0]));
}
//# sourceMappingURL=index.js.map